export const roundToTwoDecimalPlaces = (number) => {
    return String(parseFloat(number).toFixed(2));
};
